import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Spin } from 'grab-ui';
import styles from './pay-sdk-status-view.less';

/**
 * Shared loading/error states for PaySDK components.
 * Renders error or loading UI; otherwise renders children.
 */
const PaySdkStatusView = ({
  loadError,
  scriptLoaded,
  errorFallbackKey,
  children,
}) => {
  if (loadError) {
    return (
      <div className={styles.error}>
        {loadError.message || I18n.t(errorFallbackKey)}
      </div>
    );
  }

  if (!scriptLoaded) {
    return (
      <div className={styles.loading}>
        <Spin tip={I18n.t('v2.homepage.manualOrder.loadingPaymentOptions')} />
      </div>
    );
  }

  return children;
};

PaySdkStatusView.propTypes = {
  loadError: PropTypes.instanceOf(Error),
  scriptLoaded: PropTypes.bool.isRequired,
  errorFallbackKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

PaySdkStatusView.defaultProps = {
  loadError: undefined,
};

export default PaySdkStatusView;
